import presenceStore from '../store/presenceStore';
import { mutator } from 'satcheljs';
import { addOrUpdatePresence, changeSignInState } from '../actions/presenceActions';

export const addOrUpdatePresenceMutator = mutator(addOrUpdatePresence, actionMessage => {
    const { sipUri, newPresence } = actionMessage;
    const { presences } = presenceStore;
    presences.set(sipUri, newPresence);
});

export const changeSignInStateMutator = mutator(changeSignInState, actionMessage => {
    const { newSignInState } = actionMessage;
    presenceStore.signInState = newSignInState;
});
